export default {
  retail: null,
  retailArchived: null,
  retailSubdealers: null,
  retailPartner: null,
  statusList: [],
  orderDetail: null,
  suppliersOrder: null,
  suppliersOrderArchived: null,
  dealersOrder: null,
  dealersOrderArchived: null,
  positions: '',
  addReclamation: false,
  orderReclamationCancel: false,
  per_page: 25,
  page: 1,
  triggerUpdateOrdersList: false,
}
